import { action } from 'mobx';

import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore, GenericStore } from 'ui/base/input';

import { createPortFilter } from 'ui/history/protocol_entry/protocol_entry_logic';
import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';

import { TransportProtocolFilter } from 'services/pangolin/types';

import { TransportProtocol } from 'assets/enums/protocols/protocols';

class TransportProtocolStore extends GenericStore<TransportProtocol|undefined> {}

export class PortInputStore {
  search: SearchInputStore;

  protocol: TransportProtocolStore;
  port: StringStore;

  modal: ModalStore;
  isValid: BooleanStore;

  constructor() {
    this.search = new SearchInputStore();
    this.protocol = new TransportProtocolStore(undefined);
    this.port = new StringStore('');
    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
  }

  @action.bound
  commit(): TransportProtocolFilter | undefined {
    if (/^[0-9]+$/.test(this.port.value)) {
      const port = parseInt(this.port.value);
      if (!isNaN(port) && 0 <= port && port <= 65535) {
        this.isValid.setValue(true);
        return createPortFilter(this.protocol.value, port);
      }
    }
    this.isValid.setValue(false);
    return undefined;
  }

  @action.bound
  showModal() {
    this.protocol.setValue(undefined);
    this.port.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
